export var MarketplaceProduct = Object.freeze({
  JIRA: 'jira',
  CONFLUENCE: 'confluence'
});
export var AppInstallPermission = Object.freeze({
  CAN_INSTALL_FREE_AND_PAID: 'CAN_INSTALL_FREE_AND_PAID',
  CAN_INSTALL_FREE_ONLY: 'CAN_INSTALL_FREE_ONLY',
  CANNOT_INSTALL: 'CANNOT_INSTALL'
});
export var StargateCloudProduct = Object.freeze({
  HIPCHAT: 'hipchat.cloud',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  CONFLUENCE: 'confluence.ondemand'
});
export var StargateAPIErrorCode = Object.freeze({
  UNAUTHORIZED: 'UNAUTHORIZED_ERROR',
  UNKNOWN: 'UNKNOWN_ERROR'
});
export var StargatePermissionId = Object.freeze({
  ADD_PRODUCTS: 'add-products',

  /** @deprecated Legacy. Use `ADD_PRODUCTS` instead */
  ADD_PRODUCT: 'addProduct',
  INVITE_USERS: 'invite-users',
  MANAGE: 'manage',
  WRITE: 'write'
});